import { css } from 'lit';

var css_248z = css`.form-control-icon{bottom:0}`;

export { css_248z as default };
//# sourceMappingURL=sgds-combo-box2.js.map
